/**
 * Setear lista de categorias
 */
export function setCategories(state, categories) {
    state.category_lists = categories
}

/**
 * Actualizar filtro frases
 */
export function setDataFilterPhrases(state, {product_id, company_id}) {
    state.filter.product_id = product_id;
    state.filter.company_id = company_id;
}

/**
 * Agregar frases de un producto.
 */
export function setEtProductPhrases(state, et_product_phrases) {
    state.et_product_phrases = et_product_phrases;
}

/**
 * Agregar informacion completa sobre sga
 */
export function setCompleteSga(state, complete_sga) {
    state.complete_sga = complete_sga;
}

/**
 * Cambiar el idioma.
 */
export function changeLanguaje(state, idioma) {
    state.languaje = idioma;
}

/**
 * Cambiar el tipo.
 */
export function changeType(state, type) {
    state.type = type;
}







